//get Contact Us
export const GET_CONTACT_US = "GET_CONTACT_US";

//Insert Contact Us
export const INSERT_CONTACT_US = "INSERT_CONTACT_US";

//Update Contact Us
export const UPDATE_CONTACT_US = "UPDATE_CONTACT_US";

//Delete Contact Us
export const DELETE_CONTACT_US = "DELETE_CONTACT_US";

//Open and Close Dialog
export const OPEN_CONTACT_DIALOG = "OPEN_CONTACT_DIALOG";
export const CLOSE_DIALOG = "CLOSE_INSERT_DIALOG";

//toast
export const OPEN_CONTACT_US_TOAST = "OPEN_CONTACT_US_TOAST";
export const CLOSE_CONTACT_US_TOAST = "CLOSE_CONTACT_US_TOAST";
